import React from "react";
import { Container, Button, Text } from "./styled/slider-nav";
function SliderNav(_a) {
    var _b = _a.currentSlideIndex, currentSlideIndex = _b === void 0 ? 0 : _b, _c = _a.slideCount, slideCount = _c === void 0 ? 0 : _c, _d = _a.dotsToShow, dotsToShow = _d === void 0 ? 0 : _d, _e = _a.slideSpeed, slideSpeed = _e === void 0 ? 0 : _e, _f = _a.onClick, onClick = _f === void 0 ? function () { } : _f;
    var newDotsToShow = dotsToShow;
    var dotsToShowHalf = Math.floor(dotsToShow / 2);
    var atBeginning = currentSlideIndex < dotsToShowHalf;
    var atEnd = slideCount - currentSlideIndex <= dotsToShowHalf;
    var offset = atBeginning || atEnd ? -1 : 0;
    var isSlideCountBelowShowCount = false;
    if (slideCount < dotsToShow) {
        newDotsToShow = slideCount;
        offset = 0;
        isSlideCountBelowShowCount = true;
    }
    return (React.createElement(Container, { dotsToShow: newDotsToShow, offset: offset, "data-testid": "slider-nav" }, new Array(slideCount).fill("").map(function (_, i) {
        var isActive = currentSlideIndex === i;
        var isFirstInViewport = (atEnd
            ? slideCount - newDotsToShow + 1
            : currentSlideIndex - dotsToShowHalf) === i;
        var isLastInViewport = (atBeginning
            ? newDotsToShow - 1 + offset
            : currentSlideIndex + dotsToShowHalf) === i;
        var isInViewport = atBeginning
            ? i < newDotsToShow + offset
            : atEnd
                ? i >= slideCount - newDotsToShow - offset
                : currentSlideIndex - dotsToShowHalf - offset <= i &&
                    currentSlideIndex + dotsToShowHalf + 1 > i;
        var tabIndex = 0;
        var buttonTransform = "";
        var buttonTransition = "transform " + slideSpeed + "s";
        var itemScale = "";
        var itemTransition = "opacity " + slideSpeed + "s, transform " + slideSpeed + "s";
        if (!atBeginning && !atEnd) {
            buttonTransform = "translateX(-" + 100 * (currentSlideIndex - dotsToShowHalf) + "%)";
        }
        if (atEnd) {
            buttonTransform = "translateX(-" + 100 * (slideCount - newDotsToShow - offset) + "%)";
        }
        if (!isInViewport) {
            itemScale = "scale(0)";
            tabIndex = -1;
        }
        if ((isFirstInViewport || isLastInViewport) &&
            !isSlideCountBelowShowCount) {
            itemScale = "scale(0.7)";
        }
        if (isActive) {
            itemScale = "scale(1.3)";
        }
        if (!(currentSlideIndex % (slideCount - 1))) {
            buttonTransition = "";
            itemTransition = "";
        }
        return (React.createElement(Button, { key: i, style: {
                transform: buttonTransform,
                transition: buttonTransition,
                opacity: isActive ? 0.8 : 0.7
            }, tabIndex: tabIndex, "aria-hidden": tabIndex === -1, onClick: function () { return onClick(i); } },
            React.createElement(Text, { style: {
                    transform: itemScale,
                    transition: itemTransition
                } },
                "Slide ",
                i + 1)));
    })));
}
export default SliderNav;
